import { Injectable, Injector } from "@angular/core";
import { BaseHttpService } from "./base-http.service";
import { FileState, FileInfo } from "@progress/kendo-angular-upload";
import { HttpErrorResponse } from "@angular/common/http";
import { CgpAlertDialogService } from "../cgp-alert-dialog/cgp-alert-dialog.service";
import { utilities } from "../../../../src/modules/utility";

@Injectable()
export class S3Service extends BaseHttpService {

    private readonly alertDialog: CgpAlertDialogService;
    private readonly environment: string;
    constructor(injector: Injector) {
        super(injector);
        this.alertDialog = injector.get(CgpAlertDialogService);
        this.environment = utilities.getEnv();
    }

    /**
     * Construct url and call S3 service to remove file
     * @param file - file to remove
     * @param path - path to file e.g (CTWR/12345/)
     */
    handleS3Remove(file, path): Promise<any> {
        const url = s3config.baseUrl[this.environment] + s3config.methods.delete + s3config.s3Bucket[this.environment]
            + path + file.name;
        return this.removeS3Object(url)
            .catch(this.handleS3Error)
    }


    /**
     * Construct url and call s3 Service to copy file (recursive)
     * Attach body with source/destination info
     * @param file 
     * @param sourcePath 
     * @param destinationPath 
     */
    handleS3Copy(files: FileInfo[], sourcePath: string, destinationPath: string): Promise<any> {
        const _file: FileInfo = files.find(f => f.state < 3);
        if (!_file) return Promise.resolve();

        const url = s3config.baseUrl[this.environment] + s3config.methods.copy;
        const json = {
            SourceBucket: s3config.s3Bucket,
            SourceObject: sourcePath + _file.name,
            DestinationBucket: s3config.s3Bucket,
            DestinationObject: destinationPath + _file.name,
        }

        if (_file.state !== FileState.Uploaded) {
            return this.copyS3Object(JSON.stringify(json), url)
                .then(x => _file.state = FileState.Uploaded)
                .then(x => this.handleS3Copy(files, sourcePath, destinationPath))
                .catch(this.handleError)
        } else {
            return this.handleS3Copy(files, sourcePath, destinationPath);
        }
    }


    /**
     * Construct url and call S3 service to upload file (recursive)
     * @param files - List of files to upload
     * @param path - S3 path to file e.g.(CTWR/12345/)
     */
    handleS3Upload(files: FileInfo[], path: string): Promise<any> {
        const _file: FileInfo = files.find(f => f.state < 3);
        if (!_file) return Promise.resolve();

        const formData: FormData = new FormData();
        formData.append("file", _file.rawFile);
        const url = s3config.baseUrl[this.environment] + s3config.methods.upload + s3config.s3Bucket[this.environment]
            + path + _file.name;

        if (_file.state !== FileState.Uploaded) {
            return this.uploadS3Object(formData, url)
                .then(x => _file.state = FileState.Uploaded)
                .then(x => this.handleS3Upload(files, path))
                .catch(this.handleError)
        } else {
            return this.handleS3Upload(files, path);
        }
    }


    /**
     * 
     * @param filePath: e.g.(CTWR/12345/)
     */
    downloadS3Object = (file: FileInfo, path) => {
        if (!path) return;
        const url = s3config.baseUrl[this.environment] + s3config.methods.get + s3config.s3Bucket[this.environment] + path + file.name;

        const nav = (window.navigator as any);
        
        this.getS3Object(url)
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                if (typeof navigator !== "undefined" && nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(blob, file.name);
                }
                else {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = file.name;
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(this.handleS3Error)
    }


    /**
     * Generate S3 URL
     * param
     * filePath: Path to file in s3 bucket ex) 'PHF/PressPictures/fileName.jpg'
     */
    getS3Path = (filePath: string): string => {
        const extension = filePath.split(".")[1] === "gif" ? "gif" : "jpeg";
        return `${s3config.baseUrl[this.environment]}${s3config.methods.bytes}${s3config.s3Bucket[this.environment]}${filePath}&mediaTypeHeader=image/${extension}`;
    }

    /**
     * 
    */
    handleS3Error = (error: HttpErrorResponse) => {
        this.loading.next(false);
        if (error.status >= 200 && error.status < 400) return;
        const _body = "S3 File not found";
        const _status = `404`;
        if (this.alertDialog.isOpen()) return;
        this.alertDialog.showAlertDialog({
            title: `HTTP Error: ${_status}`,
            message: _body,
            alert: "danger",
            closeLabel: "OK"
        });
    }

}




const devBucket = "b0173294-002&s3ObjectKey=";
const qaBucket = "b0173294-002&s3ObjectKey=";
const testBucket = "b0173294-002&s3ObjectKey=";
const devURL = "https://cgp-s3-test.ocp-epgiw1.epg.nam.gm.com";
const qaURL = "https://cgp-s3-test.ocp-epgiw1.epg.nam.gm.com";
const testURL = "https://cgp-s3-test.ocp-epgiw1.epg.nam.gm.com";
export const s3config = {
    baseUrl: {
        "LOCAL": devURL,
        "DEV": devURL,
        "QA": qaURL,
        "TEST": testURL,
        "TEST_COPY": testURL,
        "PROD": "https://cgp-s3.ocp-prod2im1.gm.com",
    },
    s3Bucket: {
        "LOCAL": devBucket,
        "DEV": devBucket,
        "QA": qaBucket,
        "TEST": testBucket,
        "TEST_COPY": testBucket,
        "PROD": "b0173294-001&s3ObjectKey=",
    },
    methods: {
        copy: "/CopyS3Object",
        delete: "/DeleteS3Object?s3Bucket=",
        get: "/GetS3Object?s3Bucket=",
        bytes: "/GetS3ObjectBytes?appId=mesc2&s3Bucket=",
        upload: "/UploadFile?s3Bucket=",
    },
}

